/* eslint-disable no-unused-vars */
import axios from "axios";

const BASE_URL_LOCAL = process.env.REACT_APP_BASE_URL_LOCAL; //"http://127.0.0.1:5001/hem-tech/us-central1";
const BASE_URL_PROD = process.env.REACT_APP_BASE_URL_PROD; //"https://us-central1-hem-tech.cloudfunctions.net";

const BASE_URL = BASE_URL_PROD; //BASE_URL_PROD;

export const getChatAnswer = async (data) => {
  try {
    const response = await axios.post(`${BASE_URL}/getChatAnswer`, data);

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getImageCreationAnswer = async (data) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/getImageCreationAnswer`,
      data
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getImageVariationAnswer = async (data) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/getImageVariationAnswer`,
      data
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getChatAnswerWithFile = async (data) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/getChatAnswerWithFile`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createAssistantThread = async () => {
  try {
    const response = await axios.post(`${BASE_URL}/createAssistantThread`);

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAnswerFromThreads = async (data) => {
  try {
    const response = await axios.post(`${BASE_URL}/getAnswerFromThreads`, data);

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAnswerFromFileThreads = async (data) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/getAnswerFromFileThreads`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getFineTuneJobRetrieve = async (data) => {
  try {
    const response = await axios.post(`${BASE_URL}/getFineTuneJobRetrieve`, {
      data,
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchSpeech = async (data, signal, onChunkFetched) => {
  try {
    const { model, voice, text, speed } = data;
    const chunks = splitText(text);
    let currentBlobPromise = fetchAudioChunk(model, voice, chunks[0], speed, signal);

    for (let i = 0; i < chunks.length; i++) {
      const nextChunkIndex = i + 1;
      let nextChunkPromise = null;

      if (nextChunkIndex < chunks.length) {
        nextChunkPromise = fetchAudioChunk(
          model,
          voice,
          chunks[nextChunkIndex],
          speed,
          signal
        );
      }

      const currentBlob = await currentBlobPromise;

      // Call the callback with the current chunk's response
      if (onChunkFetched) {
        onChunkFetched(currentBlob);
      }

      await playAudioBlob(currentBlob, signal);

      if (nextChunkPromise) {
        currentBlobPromise = nextChunkPromise;
      }
    }
  } catch (error) {
    // Handle AbortError gracefully - this is expected when stopping audio
    if (error.name === 'AbortError') {
      // Silently handle abort - this is normal user behavior
      return;
    }
    // Re-throw other errors
    throw error;
  }
};

async function fetchAudioChunk(model, voice, text, speed, signal) {
  try {
    const response = await fetch(`${BASE_URL}/synthesizeSpeech`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ model, voice, text, speed }),
      signal,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.blob();
  } catch (error) {
    // Handle AbortError specifically - suppress and re-throw silently
    if (error.name === 'AbortError') {
      throw error; // Re-throw original abort error without modification
    }
    throw error;
  }
}

function splitText(text) {
  return text.split(/(?<=\.)/g).filter((chunk) => chunk.trim().length > 0);
}

let currentAudio = null;

async function playAudioBlob(blob, signal) {
  return new Promise((resolve, reject) => {
    // Check if already aborted before starting
    if (signal && signal.aborted) {
      const abortError = new Error();
      abortError.name = 'AbortError';
      reject(abortError);
      return;
    }

    const audio = new Audio(URL.createObjectURL(blob));

    // Handle abort signal
    if (signal) {
      signal.addEventListener('abort', () => {
        audio.pause();
        if (currentAudio === audio) {
          currentAudio = null;
        }
        // Create a silent abort error
        const abortError = new Error();
        abortError.name = 'AbortError';
        reject(abortError);
      }, { once: true });
    }

    // Stop any previous audio before starting new one
    if (currentAudio && currentAudio !== audio) {
      currentAudio.pause();
      currentAudio.currentTime = 0;
    }

    currentAudio = audio; // Store the reference to the current audio

    audio.play().catch((playError) => {
      if (currentAudio === audio) {
        currentAudio = null;
      }
      // Check if this is due to abort signal
      if (signal && signal.aborted) {
        const abortError = new Error();
        abortError.name = 'AbortError';
        reject(abortError);
      } else {
        reject(new Error(`Audio playback failed: ${playError.message}`));
      }
    });

    audio.onended = () => {
      if (currentAudio === audio) {
        currentAudio = null; // Clear the reference when audio ends
      }
      resolve();
    };
    audio.onerror = () => {
      if (currentAudio === audio) {
        currentAudio = null; // Clear the reference on error
      }
      reject(new Error("Audio playback failed"));
    };
  });
}

export function stopAudio() {
  if (currentAudio) {
    currentAudio.pause();
    currentAudio.currentTime = 0; // Reset the audio to the beginning
    currentAudio = null; // Clear the reference
  }
}

export const getGeneratedPDF = async (data) => {
  try {
    const response = await axios.post(`${BASE_URL}/generatePdf`, data);
    return response.data;
  } catch (error) {
    console.error('Error retrieving chat answer:', error);
    throw error;
  }
};

// ══════════════════════════════════════════════════════════════════════════════
// ██  GENKIT API Functions
// ══════════════════════════════════════════════════════════════════════════════

export const getGenkitChatAnswer = async (data) => {
  try {
    const response = await axios.post(`${BASE_URL}/genkitChatAnswer`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getGenkitImageCreation = async (data) => {
  try {
    const response = await axios.post(`${BASE_URL}/genkitImageCreation`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getGenkitChatAnswerWithFile = async (data) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/genkitChatAnswerWithFile`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getGenkitImageVariation = async (data) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/genkitImageVariation`,
      data
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchGenkitSpeech = async (data, signal, onChunkFetched) => {
  try {
    const { model, voice, voiceName, text, speakingRate, pitch, volumeGainDb } = data;
    const chunks = splitText(text);

    for (let i = 0; i < chunks.length; i++) {
      if (signal && signal.aborted) {
        const abortError = new Error();
        abortError.name = 'AbortError';
        throw abortError;
      }

      const response = await fetch(`${BASE_URL}/genkitSpeechSynthesis`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          model,
          voice,
          voiceName,
          text: chunks[i],
          speakingRate: speakingRate !== undefined ? speakingRate : data.speed,
          pitch,
          volumeGainDb,
        }),
        signal,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const blob = await response.blob();

      if (onChunkFetched) {
        onChunkFetched(blob);
      }

      await playAudioBlob(blob, signal);
    }
  } catch (error) {
    if (error.name === 'AbortError') {
      return;
    }
    throw error;
  }
};

export const getAgentAnswer = async (data) => {
  try {
    const response = await axios.post(`${BASE_URL}/getAgentAnswer`, data);

    return response.data;
  } catch (error) {
    throw error;
  }
};
